<template>
  <div>
    <h5 class="mb-1">{{ title }}</h5>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <validation-provider
        #default="validationContext"
        :name="$tc('hanwha_camera.name')"
        rules="required"
      >
        <b-form-group
          class="text-capitalize"
          :label="$tc('hanwha_camera.name')"
          label-for="user_group_id"
          :state="getValidationState(validationContext)"
        >
          <b-form-input
            id="user_group_id"
            v-model="itemData.user_group_id"
            :state="getValidationState(validationContext)"
            trim
            maxlength="16"
            :disabled="itemData.isEdit"
          />

          <b-form-invalid-feedback :state="getValidationState(validationContext)">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
    </validation-observer>
    <b-form-group
      class="text-capitalize"
      label="Permisos"
    >
      <b-tabs v-model="activeTab" justified>
        <b-tab
          v-for="(tab, index) in permissionsTabs"
          :key="index"
          :title="tab.name"
        >
          <template #title>
             <feather-icon :icon="tab.icon" size="18"/> {{ tab.name }}
          </template>
          <keep-alive>
            <component
              :channels="channels"
              :is="tab.component"
              :item-data="itemData"
            />
          </keep-alive>
        </b-tab>
      </b-tabs>
    </b-form-group>
  </div>
</template>

<script>
import { computed,ref } from "@vue/composition-api";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import ExportPermissions from "./ExportPermissions.vue";
import GeneralPermissions from "./GeneralPermissions.vue";
import MenuPermissions from "./MenuPermissions.vue";
import SearchChannelPermissions from "./SearchChannelPermissions.vue";

export default {
  components: {
    flatPickr,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  props: {
    channels: {
      type: Array
    },
    hanwhaDvr: {
      type: Object
    },
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { refFormObserver, getValidationState } = formValidation();

    const { t } = useI18nUtils();

    //DATA
    const activeTab = ref(0);

    const permissionsTabs = ref([
      {
        name: 'General',
        component: GeneralPermissions,
        icon: 'InfoIcon'
      },
      {
        name: t('hanwha_dvr.groups_permissions.export.name'),
        component: ExportPermissions,
        icon: 'ShareIcon'
      },
      {
        name: 'Menu',
        component: MenuPermissions,
        icon: 'MenuIcon'
      },
      {
        name: t('hanwha_dvr.groups_permissions.search_channel.name'),
        component: SearchChannelPermissions,
        icon: 'RssIcon'
      }
    ]);

    //COMPUTED
    const title = computed(() => (props.itemData.isEdit) ? `${t('actions.update')} ${t('hanwha_camera.group')}` : `${t('actions.add')}  ${t('hanwha_camera.group')}`);

    //METHODS
    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Validation observer is not initialized");
        return false;
      }

      const validation = await refFormObserver.value.validate();

      return validation;
    }

    return {
      getValidationState,
      refFormObserver,

      activeTab,
      permissionsTabs,

      title,

      validateStep,
      withPopper: popperHelper.withPopper
    }
  }
}
</script>
